"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETopicType = void 0;
var ETopicType;
(function (ETopicType) {
    ETopicType[ETopicType["ALL"] = 0] = "ALL";
    ETopicType[ETopicType["PRE_CLINICAL"] = 1] = "PRE_CLINICAL";
    ETopicType[ETopicType["CLINICAL"] = 2] = "CLINICAL";
    ETopicType[ETopicType["ANATOMY"] = 3] = "ANATOMY";
    ETopicType[ETopicType["DATA_INTERPRETATION"] = 4] = "DATA_INTERPRETATION";
    ETopicType[ETopicType["PSA"] = 5] = "PSA";
    ETopicType[ETopicType["OSCE"] = 6] = "OSCE";
    ETopicType[ETopicType["MOCK_TEST"] = 7] = "MOCK_TEST";
    ETopicType[ETopicType["SJT"] = 8] = "SJT";
    // new interview product topic types
    ETopicType[ETopicType["INTERVIEW_ANAESTHETICS"] = 9] = "INTERVIEW_ANAESTHETICS";
    ETopicType[ETopicType["INTERVIEW_CST"] = 10] = "INTERVIEW_CST";
    ETopicType[ETopicType["INTERVIEW_IMT"] = 11] = "INTERVIEW_IMT";
    ETopicType[ETopicType["INTERVIEW_RADIOLOGY"] = 12] = "INTERVIEW_RADIOLOGY";
    ETopicType[ETopicType["INTERVIEW_PAEDIATRICS"] = 13] = "INTERVIEW_PAEDIATRICS";
    ETopicType[ETopicType["UCAT"] = 14] = "UCAT";
})(ETopicType = exports.ETopicType || (exports.ETopicType = {}));
